<template>
  <div :class="[
      'main-block-container',
      {'is-active-mini' : isActiveMiniParagraph },
      `${configBlock?.theme || 'default'}-theme`,
      `${configBlock?.textAlign || 'left'}-align-block`
  ]">
    <medium-title
        :font-family="$isMobile
              ? 'EurostileR'
              : 'Eurostile'" class="main-title-container">
      {{ mainTitle }}
    </medium-title>
    <big-paragraph v-if="mainParagraph"
                   :line-height="'big'"
                   :class="[
                       'main-paragraph-container'
                   ]">
      {{ mainParagraph }}
    </big-paragraph>
    <div class="actions-container"
         v-if="configBlock?.btnInfo">
      <main-button
          @click="configBlock?.btnInfo?.action()">
        {{ configBlock?.btnInfo?.btnText }}
      </main-button>
      <button-request
          v-if="configBlock?.activeRequest"/>
    </div>

  </div>
</template>

<script>
import MediumTitle from "@/components/shared/text/MediumTitle.vue";
import MainButton from "@/components/shared/MainButton.vue";
import BigParagraph from "@/components/shared/text/BigParagraph.vue";
import ButtonRequest from "@/components/shared/static/ButtonRequest.vue";

export default  {
  name: "MainTextBlock",
  components: {ButtonRequest, BigParagraph, MainButton, MediumTitle},
  props: {
    mainTitle: {
      type: String,
      required: true
    },
    mainParagraph: {
      type: String
    },
    isActiveMiniParagraph: {
      type: Boolean,
      default: false
    },
    configBlock: {
      type: Object,
      default: {
        theme: 'default',
        textAlign: 'left',
        // btnInfo: {
        //   btnText: 'btnText',
        //   action: () => console.log('a')
        // }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .main-block-container {
    display: flex;
    flex-direction: column;

    .main-title-container {
      white-space: pre-wrap;
    }
    .actions-container {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    &.dark-theme {
      .main-paragraph-container {
        color: var(--color-light-grey);
      }
      .main-title-container {
        color: var(--color-dark-purple);
      }
    }

    .main-paragraph-container {
      white-space: pre-wrap;
      color: var(--color-purple-grey);
    }

    &.center-align-block {
      align-items: center;
      text-align: center;
    }
  }
  @media (max-width: 3024px){
    .main-block-container {
      row-gap: 40px;


      .actions-container {
        column-gap: 40px;
      }
    }
  }


  @media (max-width: 1600px) {
    .main-block-container {
      row-gap: 30px;
    }
  }
  @media (max-height: 800px) {
    .main-block-container {
      row-gap: 20px;
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {
    .main-block-container {
      row-gap: 30px;
    }
  }

  @media (max-width: 1133px) {
    .main-block-container {
      row-gap: 20px;
    }
  }
  @media (max-width: 769px) {

    .main-block-container {
      row-gap: 24px;
      &.is-active-mini {
        row-gap: 24px;
        .main-paragraph-container {
          font-size: 12px;
        }
      }

      .actions-container {
        align-items: flex-start;
        flex-direction: column;
        row-gap: 16px;
      }
    }
    .main-paragraph-container {
      font-size: 14px;
    }
    //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {
    .main-block-container {
      row-gap: 120px;

      .actions-container {
        column-gap: 80px;
      }
    }
  }

</style>